module.exports = __webpack_public_path__ + "img/study_flow.13439bdd.png";